export const Marquee = () => {
  const items = [
    "Protection",
    "Peace",
    "Presence",
    "Private",
    "Safe",
    "Luxury",
  ];
  // Duplicate twice for seamless loop
  const set = [...items, ...items, ...items, ...items];

  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[#0D0814]/60 overflow-hidden py-5"
    >
      <div className="marquee-track flex items-center gap-12 whitespace-nowrap">
        {set.map((t, i) => (
          <span
            key={i}
            className="flex items-center gap-12 font-sans text-xs sm:text-sm uppercase tracking-[0.4em] text-[#D4AF37]/80"
          >
            {t}
            <span className="w-1 h-1 rounded-full bg-[#D4AF37]/60" />
          </span>
        ))}
      </div>
    </div>
  );
};
